module.exports = __webpack_public_path__ + "img/widget_share.4f44fdb.svg";